var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useWallet } from '@tronweb3/tronwallet-adapter-react-hooks';
import { useEffect, useRef, useState } from 'react';
import React, { useCallback, useMemo } from 'react';
import { Button } from './Button.js';
import { WalletSelectButton } from './WalletSelectButton.js';
import { WalletConnectButton } from './WalletConnectButton.js';
import { Collapse } from './Collapse.js';
import { useWalletModal } from './useWalletModal.js';
import { copyData } from './utils.js';
export const WalletActionButton = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { address, wallet, disconnect } = useWallet();
    const { setVisible } = useWalletModal();
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [copied, setCopied] = useState(false);
    const ref = useRef(null);
    const content = useMemo(() => {
        if (children)
            return children;
        if (!wallet || !address)
            return null;
        return address.slice(0, 4) + '...' + address.slice(-4);
    }, [children, wallet, address]);
    const copyAddress = () => {
        if (address) {
            copyData(address);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
                hideDropdown();
            }, 400);
        }
    };
    function changeWallet() {
        setVisible(true);
        hideDropdown();
    }
    const openDropdown = useCallback(function () {
        setDropdownVisible(true);
    }, []);
    const hideDropdown = useCallback(function () {
        setDropdownVisible(false);
    }, []);
    const handleDisconnect = useCallback(function () {
        return __awaiter(this, void 0, void 0, function* () {
            yield disconnect();
            hideDropdown();
        });
    }, [disconnect, hideDropdown]);
    useEffect(() => {
        const listener = (event) => {
            const node = ref.current;
            if (!node || node.contains(event.target))
                return;
            hideDropdown();
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, hideDropdown]);
    if (!wallet)
        return (React.createElement(WalletSelectButton, Object.assign({ onClick: hideDropdown }, props), children));
    return (React.createElement("div", { "data-testid": "wallet-action-button", className: "adapter-dropdown" },
        !address ? (React.createElement("div", { onMouseEnter: openDropdown, onMouseLeave: hideDropdown },
            React.createElement(WalletConnectButton, Object.assign({}, props), children))) : (React.createElement(Button, Object.assign({ onClick: openDropdown, style: Object.assign({ pointerEvents: dropdownVisible ? 'none' : 'auto' }, props.style), icon: wallet ? wallet.adapter.icon : '' }, props), content)),
        React.createElement(Collapse, Object.assign({ className: "adapter-dropdown-collapse", isOpen: dropdownVisible }, (!address ? { onMouseEnter: openDropdown, onMouseLeave: hideDropdown } : {})),
            React.createElement("ul", { ref: ref, className: "adapter-dropdown-list", role: "menu" },
                address && (React.createElement("li", { onClick: copyAddress, className: "adapter-dropdown-list-item", role: "menuitem" }, copied ? 'Copied' : 'Copy address')),
                React.createElement("li", { onClick: changeWallet, className: "adapter-dropdown-list-item", role: "menuitem" }, "Change wallet"),
                address && (React.createElement("li", { onClick: handleDisconnect, className: "adapter-dropdown-list-item", role: "menuitem" }, "Disconnect"))))));
};
//# sourceMappingURL=WalletActionButton.js.map